'use strict';

goog.provide("Ntry.JrHelper");

Ntry.JrHelper = function() {
    Ntry.addEventListener("helperAction", this, this.actions);
};

(function(p) {

    p.update = function() {
        if (!this.executeEndEvent && this.workspace.board.code) {
            this.executeEndEvent = this.workspace.board.code.executeEndEvent.attach(this, function(help) {
                console.log(232323);
                this._played.push(help);
                this.actions();
            });
        }
    };

    p.loadConfig = function() {
        var self = this;

        this._played = [];
        this._play = false;

        this._helper = Ntry.configManager.getConfig("helper");

        this.workspace = Entry.mainWorkspace;

        //this.actions(this._helper);
    };

    p.actions = function() {
        var playedCount = this._played ? this._played.length : 0;
        if (playedCount < this._helper.length)
            this.action(this._helper[playedCount]);
        else
            return;

    };

    p.action = function(help) {
        if (help.action == 'add') {
            this.workspace.playAddBlock(help);
        } else if (help.action == 'click') {
            this.playClick(help);
        } else if (help.action == 'move') {
            this.playMove(help);
        } else if (help.action == 'delete') {
            this.playDelete(help);
        }
    };

    p.playClick = function(help) {
        var self = this;

        var target = $('#'+help.target);
        if (target) {
            var pos = target.position();
            target.click();
            setTimeout(function() {
                console.log('notify playClick finish');
                self._stopEvent.notify(help);
            }, help.duration);
        } else {
            this._play = false;
        }
    };

    p.playMove = function(help) {
        var self = this;
        console.log('playMove help');
        //TODO
        setTimeout(function() {
            console.log('stop playMove');
            self._stopEvent.notify(help);
        }, help.duration);
    };

    p.playDelete = function(help) {
        var self = this;
        console.log('playDelete help');
        //TODO
        setTimeout(function() {
            console.log('stop playDelete');
            self._stopEvent.notify(help);
        }, help.duration);
    };


})(Ntry.JrHelper.prototype);
